export default __webpack_public_path__ + "static/plantcovers-89172e83f241c4b73d2cec504f180e91.jpg";